import { defaultTableState } from '../../models/redux/DefaultTableState';
import * as types from './types';

export interface TableState {
  tables: any;
  history: any[];
}

const tableState: TableState = {
  tables: {},
  history: [] as any[]
};

const TableReducer = (state = tableState, action: any) => {
  switch (action.type) {
    case types.INIT_STATE: {
      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: defaultTableState,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            filters: action.payload.filters,
            loading: true
          }
        }
      };
      break;
    }
    case types.SET_LOADING: {
      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            loading: action.payload.loading
          }
        }
      };
      break;
    }
    case types.FETCH_TABLE_FULFILLED: {
      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            tableData: action.payload.data,
            loading: false
          }
        }
      };
      break;
    }
    case types.FETCH_TABLE_ERROR: {
      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            tableData: [],
            loading: false
          }
        }
      };
      break;
    }
    case types.SET_PAGINATION: {
      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            pagination: action.payload.data
          }
        }
      };
      break;
    }
    case types.FETCH_COUNT_FULFILLED: {
      const count = getCountFromPayload(action.payload.data);

      state = {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.stateKey]: {
            ...state.tables[action.payload.stateKey],
            pagination: {
              ...state.tables[action.payload.stateKey].pagination,
              total: count
            }
          }
        }
      };
      break;
    }
  }

  return state;
};

const getCountFromPayload = (payload: any) => {
  if (!payload) {
    return null;
  }

  if (Array.isArray(payload.data)) {
    return payload.data.length;
  }

  return payload.count;
};

export { TableReducer };
